module.exports = __webpack_public_path__ + "static/media/construction-security.78b225a4.jpg";